import { useEffect, useMemo, useRef, useState } from 'react'

interface UseCountdownResult {
  segundosRestantes: number
  expirado: boolean
  formatado: string
}

function calcularRestantes(alvoMs: number): number {
  const diff = Math.ceil((alvoMs - Date.now()) / 1000)
  return diff > 0 ? diff : 0
}

function formatar(segundos: number): string {
  const m = Math.floor(segundos / 60)
  const s = segundos % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export default function useCountdown(expiraEm: string): UseCountdownResult {
  const alvoMs = useMemo(() => new Date(expiraEm).getTime(), [expiraEm])

  const [segundosRestantes, setSegundosRestantes] = useState<number>(() =>
    calcularRestantes(alvoMs)
  )
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    setSegundosRestantes(calcularRestantes(alvoMs))

    intervalRef.current = setInterval(() => {
      const restantes = calcularRestantes(alvoMs)
      setSegundosRestantes(restantes)
      if (restantes <= 0 && intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }, 1000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [alvoMs])

  return {
    segundosRestantes,
    expirado: segundosRestantes <= 0,
    formatado: formatar(segundosRestantes),
  }
}